import api from './api';

// Obtener todos los productos por tienda
export const getAllProductsByStore = async () => {
  try {
    const response = await api.get('/products-by-store');
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos por tienda:', error);
    throw error;
  }
};

// Obtener productos de una tienda específica
export const getProductsByStoreId = async (storeId) => {
  try {
    const response = await api.get(`/products-by-store/store/${storeId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos de la tienda:', error);
    throw error;
  }
};

// Asignar producto a tienda
export const assignProductToStore = async (productId, storeId, par, reorderPoint, orderByThe) => {
  try {
    const response = await api.post('/products-by-store', { productId, storeId, par, reorderPoint, orderByThe });
    return response.data;
  } catch (error) {
    console.error('Error al asignar producto a tienda:', error);
    throw error;
  }
};

// Asignar múltiples productos a tienda
export const assignMultipleProductsToStore = async (productIds, storeId) => {
  try {
    const promises = productIds.map(productId =>
      api.post('/products-by-store', { productId, storeId, par: null, reorderPoint: null, orderByThe: null })
    );
    const results = await Promise.allSettled(promises);
    return {
      success: true,
      results: results.map((result, index) => ({
        productId: productIds[index],
        success: result.status === 'fulfilled',
        error: result.status === 'rejected' ? result.reason : null
      }))
    };
  } catch (error) {
    console.error('Error al asignar múltiples productos:', error);
    throw error;
  }
};

// Actualizar producto en tienda
export const updateProductInStore = async (id, par, reorderPoint, orderByThe) => {
  try {
    const response = await api.put(`/products-by-store/${id}`, { par, reorderPoint, orderByThe });
    return response.data;
  } catch (error) {
    console.error('Error al actualizar producto en tienda:', error);
    throw error;
  }
};

// Eliminar producto de tienda
export const removeProductFromStore = async (id) => {
  try {
    const response = await api.delete(`/products-by-store/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar producto de tienda:', error);
    throw error;
  }
};

// Importar productos por tienda desde Excel
export const importProductsByStore = async (file, storeId, onProgress) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('storeId', storeId);

    const response = await api.post('/products-by-store/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percent);
        }
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error importing products by store:', error);
    throw error;
  }
};